import axios from 'axios';
import { tecommon } from '@/config';

export default {
  async getCNZipData(params) {
    try {
      const res = await axios.get(`${tecommon}api/CNZipData`, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
};
